"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const config_1 = require("../../../../web/firebase/config");
const Colors_1 = __importDefault(require("../../../assets/colors/Colors"));
const components_1 = require("../../../components");
const InputField_1 = __importDefault(require("../../../components/input/InputField"));
const LoadingLogin_1 = __importDefault(require("../../../components/loading/LoadingLogin"));
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const constants_1 = require("../../../constants");
const constants_2 = __importDefault(require("../../../constants/constants"));
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const AsyncStorage_1 = __importDefault(require("../../../utils/AsyncStorage"));
const helpler_1 = require("../../../utils/helpler");
const scale_1 = require("../../../utils/scale");
const DisconnectScreen_1 = require("../../DisconnectScreen");
const styles_1 = __importDefault(require("./styles"));
const EditPhoneScreen = () => {
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    const { phone_number, change_phone_number_flag } = (0, react_redux_1.useSelector)((state) => state.loginReducer.userInformation);
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    const [message, setMessage] = (0, react_1.useState)('');
    const refInputValue = (0, react_1.useRef)('');
    const recaptchaVerifier = (0, react_1.useRef)();
    const handleAuthPhoneNumber = async () => {
        refInputValue.current = refInputValue.current.trim();
        if (!change_phone_number_flag) {
            setMessage("SMS認証の試行回数が規定の上限に達しました。翌日以降に再度お試しください。");
            return;
        }
        if (!refInputValue.current) {
            setMessage("電話番号は空白にできません");
        }
        else if (!constants_1.REGEX_PHONE_NUMBER_JP.test(refInputValue.current)) {
            setMessage("電話番号が無効です");
        }
        else {
            let internationalPhone = '';
            if (refInputValue.current.startsWith('0')) {
                internationalPhone = `+81${refInputValue.current.replace(/^0/, '')}`;
            }
            else {
                internationalPhone = refInputValue.current;
            }
            if (internationalPhone == phone_number) {
                setMessage("この電話番号は既に登録されています。");
                return;
            }
            setMessage('');
            if (react_native_1.Platform.OS === 'web') {
                sendOTPWeb(internationalPhone);
            }
            else {
                // APP HANDLE
            }
        }
    };
    const sendOTPWeb = (internationalPhone) => {
        setLoading(true);
        if (!recaptchaVerifier.current) {
            recaptchaVerifier.current = new config_1.firebase.auth.RecaptchaVerifier('recaptcha-container', {
                size: 'invisible',
                callback: () => { },
            });
        }
        config_1.firebase
            .auth()
            .signInWithPhoneNumber(internationalPhone, recaptchaVerifier.current)
            .then(async (confirmResult) => {
            await AsyncStorage_1.default.set(constants_2.default.CHANGE_PHONE_NUMBER, internationalPhone);
            (0, rootNavigation_1.navigate)(Routes_1.default.VERIFY_PHONE_SCREEN, { confirm: confirmResult });
        })
            .catch((error) => {
            switch (error?.code) {
                case 'auth/invalid-phone-number':
                    return setMessage('無効な電話番号です。');
                case 'auth/quota-exceeded':
                    return setMessage('利用制限に達しました。管理者にお問い合わせください。');
                case 'auth/too-many-requests':
                    return setMessage('リクエストが集中しています。\n時間を置いて再度お試しください。');
                case 'auth/unknown':
                    return setMessage('予期せぬエラーが発生しました。');
                default:
                    return setMessage('電話番号が存在しません。');
            }
        })
            .finally(() => setLoading(false));
    };
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    return (react_1.default.createElement(react_native_1.Pressable, { style: {
            flex: 1,
            backgroundColor: "#F7F7F7",
            justifyContent: "space-between",
        }, onPress: react_native_1.Keyboard.dismiss, disabled: helpler_1.isWeb },
        react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: "center" }, titleStyle: {
                    alignSelf: "center",
                }, title: "電話番号の登録", styleContainer: {
                    backgroundColor: Colors_1.default.white,
                }, leftIcon: react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(12),
                        lineHeight: (0, scale_1.moderateScale)(18),
                        color: "#007AFF",
                    } }, "\u30AD\u30E3\u30F3\u30BB\u30EB") }),
            react_1.default.createElement(react_native_1.KeyboardAvoidingView, null,
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.main },
                    react_1.default.createElement(react_native_1.View, { style: { flexDirection: "row" } },
                        react_1.default.createElement(react_native_1.View, { style: styles_1.default.Rectangle }),
                        react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                                fontSize: (0, scale_1.moderateScale)(16),
                                lineHeight: (0, scale_1.moderateScale)(24),
                                color: "#292A33",
                                fontWeight: "300",
                                paddingLeft: (0, scale_1.scale)(8),
                            } }, "\u96FB\u8A71\u756A\u53F7\u306E\u767B\u9332")),
                    react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                            fontSize: (0, scale_1.moderateScale)(15),
                            lineHeight: (0, scale_1.moderateScale)(23),
                            color: "#292A33",
                            paddingTop: (0, scale_1.scale)(12),
                            marginBottom: (0, scale_1.scale)(4),
                        } }, "\u96FB\u8A71\u756A\u53F7\u8A8D\u8A3C\u3092\u884C\u3044\u307E\u3059\u3002"),
                    react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                            fontSize: (0, scale_1.moderateScale)(15),
                            lineHeight: (0, scale_1.moderateScale)(23),
                            color: "#292A33",
                            marginBottom: (0, scale_1.scale)(4),
                        } }, "\u8A8D\u8A3C\u30B3\u30FC\u30C9\u3092SMS\u3067\u304A\u9001\u308A\u3057\u307E\u3059\u306E\u3067\u3001\u9001\u4FE1\u5148\u306E\u96FB\u8A71\u756A\u53F7\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"),
                    react_1.default.createElement(react_native_1.View, { style: { flexDirection: "row" } },
                        react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                                fontSize: (0, scale_1.moderateScale)(12),
                                lineHeight: (0, scale_1.moderateScale)(18),
                                color: "#545454",
                            } }, "\u203B"),
                        react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                                fontSize: (0, scale_1.moderateScale)(12),
                                lineHeight: (0, scale_1.moderateScale)(18),
                                color: "#545454",
                            } }, "\u96FB\u8A71\u756A\u53F7\u767B\u9332\u306F1\u65E55\u56DE\u307E\u3067\u3067\u3059\u3002")),
                    react_1.default.createElement(InputField_1.default, { placeholder: "01234567890", placeholderTextColor: "#C8C8C8", label: "電話番号", keyboardType: "phone-pad", onChangeText: (text) => {
                            refInputValue.current = text;
                        }, errorText: message }),
                    react_1.default.createElement(react_native_1.View, { style: { flexDirection: "row", marginTop: (0, scale_1.scale)(8) } },
                        react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                                fontSize: (0, scale_1.moderateScale)(12),
                                lineHeight: (0, scale_1.moderateScale)(18),
                                color: "#545454",
                            } }, "\u203B"),
                        react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                                fontSize: (0, scale_1.moderateScale)(12),
                                lineHeight: (0, scale_1.moderateScale)(18),
                                color: "#545454",
                            } }, "\u30CF\u30A4\u30D5\u30F3\u3092\u5165\u308C\u305A\u306B\u534A\u89D2\u6570\u5B57\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044")),
                    react_1.default.createElement(components_1.LinearButton, { containerStyle: { marginTop: (0, scale_1.scale)(32) }, fontWeight: "600", title: "\u9001\u4FE1", onPress: handleAuthPhoneNumber })))),
        react_1.default.createElement(react_native_1.View, { id: "recaptcha-container" }),
        isLoading && react_1.default.createElement(LoadingLogin_1.default, null)));
};
exports.default = EditPhoneScreen;
